export const TEN_MINUTES_IN_MS = 10 * 60 * 1000;
export const ONE_MINUTE_IN_MS = 60 * 1000;

export const QUERY_CACHE_TIME_MS = TEN_MINUTES_IN_MS;
export const QUERY_STALE_TIME_MS = ONE_MINUTE_IN_MS;
